import { render, staticRenderFns } from "./FloatLabel.vue?vue&type=template&id=3db1f1f5"
import script from "./FloatLabel.vue?vue&type=script&lang=js"
export * from "./FloatLabel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports